module.exports = __webpack_public_path__ + "img/商业运营.af4c3d26.png";